// Misura distanza/area v2 — semantica della v1 (map-measure.js): click = vertice,
// distanza cumulata, area geodetica da 3 vertici, doppio-click/Esc chiude,
// Pulisci azzera. Resa: line+fill GeoJSON GPU + readout flottante.
let map = null;
let active = false;
let pts = []; // [lng,lat]
let readout = null;

const SRC = 'ws-measure';

function haversineM(a, b) {
    const R = 6371000, rad = Math.PI / 180;
    const dLat = (b[1] - a[1]) * rad, dLon = (b[0] - a[0]) * rad;
    const s = Math.sin(dLat / 2) ** 2 + Math.cos(a[1] * rad) * Math.cos(b[1] * rad) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
}

// Area geodetica (formula sferica dei poligoni, come geodesicArea v1).
function geodesicArea(ring) {
    const rad = Math.PI / 180, R = 6378137;
    let area = 0;
    for (let i = 0, n = ring.length; i < n; i++) {
        const p1 = ring[i], p2 = ring[(i + 1) % n];
        area += (p2[0] - p1[0]) * rad * (2 + Math.sin(p1[1] * rad) + Math.sin(p2[1] * rad));
    }
    return Math.abs(area * R * R / 2);
}

function fmtDist(m) { return m >= 1000 ? (m / 1000).toFixed(2) + ' km' : Math.round(m) + ' m'; }
function fmtArea(m2) {
    if (m2 >= 1e6) return (m2 / 1e6).toFixed(2) + ' km²';
    if (m2 >= 1e4) return (m2 / 1e4).toFixed(2) + ' ha';
    return Math.round(m2) + ' m²';
}

function totalDist() {
    let d = 0;
    for (let i = 1; i < pts.length; i++) d += haversineM(pts[i - 1], pts[i]);
    return d;
}

function refresh() {
    const src = map.getSource(SRC);
    if (!src) return;
    const features = [];
    if (pts.length >= 2) features.push({ type: 'Feature', geometry: { type: 'LineString', coordinates: pts }, properties: {} });
    if (pts.length >= 3) features.push({ type: 'Feature', geometry: { type: 'Polygon', coordinates: [[...pts, pts[0]]] }, properties: { fill: 1 } });
    for (const p of pts) features.push({ type: 'Feature', geometry: { type: 'Point', coordinates: p }, properties: { pt: 1 } });
    src.setData({ type: 'FeatureCollection', features });

    if (!readout) {
        readout = document.createElement('div');
        readout.className = 'wsv2-panel wsv2-measure-readout';
        document.body.appendChild(readout);
    }
    const dist = totalDist();
    const area = pts.length >= 3 ? geodesicArea(pts) : 0;
    readout.hidden = false;
    readout.innerHTML = `
        <strong>📏 Misura</strong>
        <span>${pts.length ? fmtDist(dist) : 'Clicca sulla mappa per iniziare'}</span>
        ${area ? `<span>Area: ${fmtArea(area)}</span>` : ''}
        <button data-clear>Pulisci</button> <button data-close>Chiudi</button>`;
    readout.querySelector('[data-clear]')?.addEventListener('click', () => { pts = []; refresh(); });
    readout.querySelector('[data-close]')?.addEventListener('click', stop);
}

function onClick(e) { pts.push([e.lngLat.lng, e.lngLat.lat]); refresh(); }
function onDbl(e) { e.preventDefault(); stop(); }
function onKey(e) { if (e.key === 'Escape') stop(); }

function start() {
    if (active) { stop(); return; }
    active = true;
    if (!map.getSource(SRC)) {
        map.addSource(SRC, { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
        map.addLayer({ id: SRC + '-fill', type: 'fill', source: SRC, filter: ['has', 'fill'], paint: { 'fill-color': '#0079b8', 'fill-opacity': 0.14 } });
        map.addLayer({ id: SRC + '-line', type: 'line', source: SRC, paint: { 'line-color': '#0079b8', 'line-width': 2.5, 'line-dasharray': [2, 1.4] } });
        map.addLayer({ id: SRC + '-pts', type: 'circle', source: SRC, filter: ['has', 'pt'], paint: { 'circle-radius': 4.5, 'circle-color': '#fff', 'circle-stroke-color': '#0079b8', 'circle-stroke-width': 2 } });
    }
    pts = [];
    map.getCanvas().style.cursor = 'crosshair';
    map.on('click', onClick);
    map.on('dblclick', onDbl);
    window.addEventListener('keydown', onKey);
    map.doubleClickZoom.disable();
    refresh();
}

function stop() {
    active = false;
    map.off('click', onClick);
    map.off('dblclick', onDbl);
    window.removeEventListener('keydown', onKey);
    map.doubleClickZoom.enable();
    map.getCanvas().style.cursor = '';
    pts = [];
    const src = map.getSource(SRC);
    if (src) src.setData({ type: 'FeatureCollection', features: [] });
    if (readout) readout.hidden = true;
}

export function initMeasure(mapInstance) {
    map = mapInstance;
    const bar = document.querySelector('.wsv2-topbar');
    const anchor = document.getElementById('btnTheme');
    const b = document.createElement('button');
    b.className = 'wsv2-iconbtn';
    b.id = 'btnMeasure';
    b.title = 'Misura distanza/area';
    b.textContent = '📏';
    b.style.fontSize = '15px';
    bar.insertBefore(b, anchor);
    b.addEventListener('click', start);
}
